/* eslint-disable jira/filename-case */
export const PACKAGE_NAME = '@jira/growth__recommend-premium-to-standard-modal';
export const TEAM_NAME = 'growth-tako';
export const ANALYTICS_SOURCE_NAME = 'recommendPremiumToStandard';
export const STARGATE_URL = '/gateway/api';
